// @flow

import $ from 'jquery'

import { assignToTest } from './actions/assign-to-test'
import { changeSelects } from './actions/change-selects'

export default () => {
  $('[name="Discipline"]').on('change', changeSelects)
  $('[name="Grade"]').on('change', changeSelects)

  $('[data-action="to-test"]').on('click', ({ currentTarget }) => {
    assignToTest($(currentTarget))
  })
}
